import type { ReactNode } from 'react';

export const symbol_weight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M217-180h526l-63-440H280l-63 440Zm263-500q25.5 0 42.75-17.25T540-740q0-25.5-17.25-42.75T480-800q-25.5 0-42.75 17.25T420-740q0 25.5 17.25 42.75T480-680Zm104 0h96q23.11 0 40.05 14.5Q737-651 740-628l62 440q4 27-13.62 47.5Q770.75-120 743-120H217q-27.75 0-45.37-20.5Q154-161 158-188l62-440q3-23 19.95-37.5Q256.89-680 280-680h96q-8-14-12-28.57-4-14.56-4-31.43 0-50 35-85t85-35q50 0 85 35t35 85q0 17-4 31.5T584-680ZM217-180h526-526Z"
		/>
	</svg>
);
